<app-center-section>
  <h1>{{ title }}</h1>
  <div [innerHTML]="body | sanitizeHtml" class="rich-text"></div>
</app-center-section>
